import { createContext } from "react";

const MainContext = createContext({
    showLoginModal: false,
    showLogin: () => {},
    hideLogin: () => {},
    loggedIn: false,
    shoppingCart: [],
    setShoppingCart: () => {},
    login: () => {},
    logout: () => {}
});

export default MainContext;
